import React from "react";
import { Link } from "react-router-dom";
import { CaretDown, MagnifyingGlass, UserCircle, SignIn } from "@phosphor-icons/react";
import { useAuth } from "../../lib/auth";
import { useAuthModal } from "../AuthModal";
import { useConsultModal } from "../ConsultModal";
import { navGroups } from "./HeaderNav";

/** Mobile-only nav drawer that slides under the header when the burger is open. */
export default function HeaderMobileMenu({ onClose, onOpenSearch }) {
  const { user, logout } = useAuth();
  const { open: openAuth } = useAuthModal();
  const { open: openConsult } = useConsultModal();
  const isAdmin = user && (user.role === "admin" || user.role === "founder");
  const isPro = user && user.role === "professional";
  const dashboardLink = isAdmin ? "/admin" : (isPro ? "/professional/dashboard" : "/dashboard");

  return (
    <div className="lg:hidden md-container md-mobile-drawer pb-6 border-t" style={{ borderColor: "var(--md-border)" }} data-testid="mobile-menu-drawer">
      <div className="flex flex-col gap-1 pt-4">
        <button onClick={() => { onOpenSearch(); onClose(); }} className="md-header-search w-full mb-2" data-testid="mobile-search-pill">
          <MagnifyingGlass size={14} weight="bold" />
          <span className="md-header-search-text">Search MindDhara</span>
        </button>
        <Link to="/about" className="py-2 text-base font-medium">About Us</Link>
        {navGroups.map((g) => (
          <details key={g.label} className="py-1">
            <summary className="py-2 text-base font-medium cursor-pointer list-none flex items-center justify-between">
              {g.label} <CaretDown size={14} />
            </summary>
            <div className="pl-4 pb-2 flex flex-col gap-1">
              {g.links.map((l) => <Link key={l.to} to={l.to} className="py-1.5 text-sm">{l.label}</Link>)}
            </div>
          </details>
        ))}
        <Link to="/events" className="py-2 text-base font-medium">Events</Link>
        <Link to="/shop" className="py-2 text-base font-medium">Shop</Link>
        <Link to="/career" className="py-2 text-base font-medium" data-testid="mobile-nav-career">Career</Link>
        <Link to="/faqs" className="py-2 text-base font-medium" data-testid="mobile-nav-faqs">FAQ</Link>
        <button onClick={() => { openConsult(); onClose(); }} className="btn-primary mt-3 justify-center" data-testid="mobile-free-consultation-cta">Free Consultation</button>
        {user ? (
          <>
            <Link to={dashboardLink} className="mt-3 md-login-chip justify-center" data-testid="mobile-dashboard">
              <UserCircle size={18} weight="duotone" />
              <span>My Account · {user.name.split(" ")[0]}</span>
            </Link>
            <button onClick={logout} className="py-2 text-sm font-medium text-left opacity-70">Logout</button>
          </>
        ) : (
          <button onClick={() => { openAuth("login"); onClose(); }} className="mt-3 md-login-chip justify-center" data-testid="mobile-login">
            <SignIn size={18} weight="duotone" />
            <span>Login</span>
          </button>
        )}
      </div>
    </div>
  );
}
